module.exports = __webpack_public_path__ + "static/img/oilApplication2.463a563a.png";